import { SdgDrillDownTableRow } from '@upright/common/model/output/scores/sdg-alignment/api-types';
import { SdgAlignmentValence, SdgId } from '@upright/common/model/output/scores/sdg-alignment/types';
import { toSdgAlignmentStrength } from '@upright/ui/common/upright/core/impact-lenses/sdg/common/utils';

export function sortTableRows(data: SdgDrillDownTableRow[], isCompany: boolean) {
  return isCompany ? sortForCompany(data) : sortForNonCompany(data);
}

export function sortExplanation(isCompany: boolean, sdg: SdgId, valence: SdgAlignmentValence) {
  const alignmentText = valence === SdgAlignmentValence.ALIGNED ? 'alignment' : 'misalignment';
  if (isCompany) {
    return `Items are sorted first by their level of ${alignmentText} with SDG ${sdg}, and then alphabetically by the product name`;
  }
  return `Constituents are sorted by their individual ${alignmentText} with SDG ${sdg}`;
}

function sortForCompany(rows: SdgDrillDownTableRow[]) {
  function sortComparator(a: SdgDrillDownTableRow, b: SdgDrillDownTableRow) {
    const strength = toSdgAlignmentStrength(b.strongestLevel) - toSdgAlignmentStrength(a.strongestLevel);
    const alpha = a.name.localeCompare(b.name);
    return strength * 100 + alpha;
  }
  return [...rows].sort(sortComparator);
}

function sortForNonCompany(rows: SdgDrillDownTableRow[]) {
  function sortComparator(a: SdgDrillDownTableRow, b: SdgDrillDownTableRow) {
    const alignment = (b.alignment || 0) - (a.alignment || 0);
    const alpha = a.name.localeCompare(b.name);
    return alignment * 100_000 + alpha;
  }

  return [...rows].sort(sortComparator);
}
